import React, { lazy } from "react";
import SSRSuspense from "../../../components/SSRSuspense/SSRSuspense";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";
import type { DogSearchProps } from "../../filters/DogSearch/ie/DogSearch";

const DogSearch: React.FC<DogSearchProps> =
	process.env.GATSBY_IS_IE === "true"
		? lazy(() => import("../../filters/DogSearch/ie/DogSearch"))
		: lazy(() => import("../../filters/DogSearch/uk/DogSearch"));

export const SectionDogSearch: React.FC = () => {
	return (
		<WrappedSection
			sectionName="SectionDogSearch"
			sectionColour={Colours.SANDY_FUR}
		>
			<SSRSuspense>
				<DogSearch />
			</SSRSuspense>
		</WrappedSection>
	);
};

export default SectionDogSearch;
